<ion-header>
  <app-header-small title="Confirmation" confirmationPage="true"></app-header-small>
</ion-header>

<ion-content *ngIf="order">
  <div class="content">
    <ion-item>
      <ion-grid>
        <ion-row>
          <ion-label> Pickup Location </ion-label>
        </ion-row>
        <ion-row>
          <ion-label class="gray-text"> {{ cartStore.pickupLocation }} </ion-label>
        </ion-row>
      </ion-grid>
    </ion-item>

    <ion-item>
      <ion-grid>
        <ion-row>
          <ion-label> Pickup Date & Time </ion-label>
        </ion-row>

        <ion-row>
          <ion-label class="gray-text"> {{ dateAndTime }} </ion-label>
        </ion-row>
      </ion-grid>
    </ion-item>

    <ion-item>
      <ion-grid>
        <ion-row>
          <ion-label> Payment </ion-label>
        </ion-row>
        <p>
          <span class="flex-end"> Subtotal </span>
          <span class="price-text">{{ getFormattedPrice(cartStore.totalPrice) | currency: currency:'symbol-narrow' }} </span>
        </p>
        <p>
          <span class="flex-end"> Taxes and fees </span>
          <span class="price-text">{{ getFormattedPrice(cartStore.totalTaxesPrice) | currency: currency:'symbol-narrow' }} </span>
        </p>
        <p>
          <span class="flex-end"> Driver Tip </span>
          <span class="price-text">{{ getFormattedPrice(cartStore.getTip(tip.driver)) | currency: currency:'symbol-narrow' }}</span>
        </p>
        <p>
          <span class="flex-end"> Restaurant Tip </span>
          <span class="price-text">{{ getFormattedPrice(cartStore.getTip(tip.restaurant)) | currency: currency:'symbol-narrow' }}</span>
        </p>
        <p>
          <span class="flex-end"> Total </span>
          <span class="price-text">
            {{ getFormattedPrice(total) | currency: currency:'symbol-narrow' }}
          </span>
        </p>
      </ion-grid>
    </ion-item>

    <ion-item *ngIf="orderConfirmationText">
      <ion-text>
        {{ orderConfirmationText }}
      </ion-text>
    </ion-item>
  </div>
</ion-content>

<ion-footer>
  <div class="footer">
    <ion-button expand="block" (click)="navigateToHome()"> All Done </ion-button>
  </div>
</ion-footer>
